import { Box } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import { forwardRef } from 'react';
import SkeletonContainer from '../../../SkeletonContainer';

export const Skeleton = () => {
  return (
    <SkeletonContainer>
      <Box css={{ marginTop: 'tight' }}>
        <Bone type="line" css={{ width: '100%', marginBottom: 'default' }} />
        <Bone type="line" />
      </Box>
    </SkeletonContainer>
  );
};

export const SkeletonListItem = forwardRef<HTMLDivElement>((_, ref) => (
  <SkeletonContainer ref={ref}>
    <Box css={{ margin: 'default' }}>
      <Bone css={{ width: '66.67%' }} />
      <Bone css={{ width: '83.33%', marginTop: 'default' }} />
    </Box>
  </SkeletonContainer>
));
